"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanValueStore = void 0;
class PlanValueStore {
    data = {};
    add(item) {
        this.data[item.getId()] = item;
    }
    byId(id) {
        return this.data[id];
    }
    query(options) {
        return Object.values(this.data).filter(p => {
            if (options.variableId !== undefined && p.getVariableId() != options.variableId) {
                return false;
            }
            if (options.startDateGte !== undefined) {
                const startDateGte = options.startDateGte.valueOf();
                if (p.getStartDate().valueOf() < startDateGte) {
                    return false;
                }
            }
            if (options.startDateEq !== undefined) {
                const startDateEq = options.startDateEq.valueOf();
                if (p.getStartDate().valueOf() !== startDateEq) {
                    return false;
                }
            }
            if (options.endDateLte !== undefined) {
                const endDateLt = options.endDateLte.valueOf();
                if (p.getEndDate().valueOf() > endDateLt) {
                    return false;
                }
                ;
            }
            if (options.endDateEq !== undefined) {
                const endDateEq = options.endDateEq.valueOf();
                if (p.getEndDate().valueOf() !== endDateEq) {
                    return false;
                }
            }
            if (options.periodLength !== undefined) {
                const pLength = p.getEndDate().valueOf() - p.getStartDate().valueOf();
                if (pLength !== options.periodLength) {
                    return false;
                }
            }
            return true;
        });
    }
    delete(id) {
        if (!this.data[id]) {
            return;
        }
        delete this.data[id];
    }
}
exports.PlanValueStore = PlanValueStore;
